import { STATUS } from '@features/General'
import { createSlice } from '@reduxjs/toolkit'

export interface IOneBadgePayload {
    badgeId: string
}

export interface IListState {
    status: string
    data: any
    errors: any
}

const initialState: IListState = {
    status: STATUS.IDLE,
    data: {},
    errors: null
}

const oneBadgeSlice = createSlice({
    name: 'badges/one-badge',
    initialState,
    reducers: {
        onRequest(state, action) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        },
        onUploadImage(state, action) {
            state.status = STATUS.RUNNING
        },
        onEditRequest(state, action) {
            state.status = STATUS.RUNNING
        },
        onEditFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const oneBadgeActions = oneBadgeSlice.actions
export default oneBadgeSlice.reducer
